import { SET_POLICY } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_POLICY: {
      return action.payload;
    }
    default:
      return state;
  }
};
